import { useStore } from '@lib/state-engine';
import { ButtonClose } from '@ui/button';
import { Informer as CInformer } from '@consta/uikit/Informer';
import { $informers, deleteInformer } from './model';
import styles from './styles.module.css';
import { notification } from 'antd';
import { useEffect } from 'react';

export const StatusInformer = () => {
  const informers = Object.values(useStore($informers));

  useEffect(() => {
    informers.map((item) => {
      const data = {
        message: item.title || item.content,
        description: item.title ? item.content : undefined,
        duration: item.timeout && !isNaN(+item.timeout) ? (+item.timeout / 1000) : 4.5,
      };
      if (item.status === 'success')
        return notification.success(data);
      if (item.status === 'warning') return notification.warning(data);
      if (item.status === 'alert') return notification.info(data);
      if (item.status === 'system') return notification.error(data);
    });
  }, [informers]);
  return (
    <></>
    // <div className={styles.container}>
    //   {informers.map(({ key, title, content, status }) => (
    //     <CInformer className={styles.informer} title={String(title)} status={status}>
    //       <ButtonClose className={styles.close} onClick={() => deleteInformer(key)} />
    //       {content}
    //     </CInformer>
    //   ))}
    // </div>
  );
};
